import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usersAPI from '../../api/users';

export default function SignupStep5({ allUserData }) {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await usersAPI.updateProfile(allUserData);
      setMessage('✅ Signup complete! Redirecting...');
      setTimeout(() => navigate('/dashboard'), 1200);
    } catch (err) {
      console.error('Error saving profile:', err);
      setMessage('❌ Failed to complete signup. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <h2 className="text-xl font-semibold mb-4">Confirm Your Details</h2>

      <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto max-h-96 mb-4">
        {JSON.stringify(allUserData, null, 2)}
      </pre>

      {message && <p className="text-center text-sm text-gray-700">{message}</p>}

      <button
        onClick={handleConfirm}
        disabled={saving}
        className="bg-green-600 text-white px-4 py-2 rounded w-full"
      >
        {saving ? 'Saving...' : 'Confirm & Finish'}
      </button>
    </div>
  );
}